import * as z from 'zod';

export const projectFormSchema = z
  .object({
    ProjectName: z.string().min(1, { message: 'PROJECT_NAME_REQUIRED' }),
    Leads: z.array(z.string()).min(1, { message: 'AT_LEAST_ONE_LEAD_REQUIRED' }),
    Members: z.array(z.string()).min(1, { message: 'AT_LEAST_ONE_MEMBER_REQUIRED' }),
  })
  .refine((data) => !data.Leads.some((id) => data.Members.includes(id)), {
    message: 'LEADS_AND_MEMBERS_MUST_NOT_OVERLAP',
    path: ['Members'],
  });

export type ProjectFormValues = z.infer<typeof projectFormSchema>;
